import useShowPWAUpdateToastEffect from "../hooks/useShowPWAUpdateToastEffect";

export default function VersionUpdateHandler() {
  useShowPWAUpdateToastEffect();
  return null;
}
